import { createFileRoute } from '@tanstack/react-router';
import ReportNavTabs from '@/featured/dashboard/report/ReportNavTabs';
import DetailReportListVoyage from '@/featured/dashboard/report/detail-report-list-voyage';

export default function ReportListVoyage() {
  return (
    <div className="w-full">
      <ReportNavTabs />
      <DetailReportListVoyage />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/report/list-voyage')({
  component: ReportListVoyage,
});
